import CustomCheckbox from "components/Atoms/CustomCheckbox"
import React, { useCallback } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { SELECT_ALL_ROWS, SELECT_ROW } from "store/selector.redux"
import classNames from "utils/classNames"

export function useRowSelector({ path, payload }) {
  const isChecked = useSelector(
    state => (state as any).selector?.[path]?.selected?.[payload.id]
  )

  const dispatch = useDispatch()
  function toggleCheck() {
    dispatch({
      type: SELECT_ROW,
      path,
      payload,
    })
  }
  return [isChecked, toggleCheck]
}
function RowSelector({ path, className = null, payload }) {
  const isChecked = useSelector(
    state => (state as any).selector?.[path]?.selected?.[payload.id]
  )

  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    dispatch({
      type: SELECT_ROW,
      path,
      payload,
    })
  }, [dispatch, payload, path])
  return (
    <div className="vt-checkbox-holder">
      <CustomCheckbox
        checked={isChecked ? true : false}
        className={classNames("vt-row-selector", className)}
        onClick={handleClick}
      />
    </div>
  )
}

export function RowSelectorAll({ path, className = null, payload }) {
  const isChecked = useSelector(
    state => (state as any).selector?.[path]?.selectAll,
    shallowEqual
  )
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    dispatch({
      type: SELECT_ALL_ROWS,
      path,
      payload,
    })
  }, [dispatch, payload, path])
  return (
    <CustomCheckbox
      checked={isChecked ? true : false}
      className={classNames(
        "vt-row-selector",
        "vt-row-selector-all",
        className
      )}
      onClick={handleClick}
    />
  )
}

export function useRowSelectorAll({ path, payload }) {
  const isChecked = useSelector(
    state => (state as any).selector?.[path]?.selectAll,
    shallowEqual
  )
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    dispatch({
      type: SELECT_ALL_ROWS,
      path,
      payload,
    })
  }, [dispatch, payload, path])

  return { isChecked, handleClick }
}
export const RowSelectorColumn = {
  show: true,
  width: 45,
  sortable: false,
  resizable: false,
  headerClassName: "vt-schedule-checkbox-header vt-checkbox-holder",
  className: "flex justify-center",
}

export default RowSelector
